import React, { useState, useEffect } from "react";
import styled from "styled-components";

const PrivacyConsent = () => {
	const [showConsentBanner, setShowConsentBanner] = useState(false);

	useEffect(() => {
		const consentGiven = localStorage.getItem("privacyConsentGiven");
		if (!consentGiven) {
			setShowConsentBanner(true);
		}
	}, []);

	const handleConsent = (consentStatus) => {
		localStorage.setItem("privacyConsentGiven", consentStatus);
		setShowConsentBanner(false);
	};

	const handleKeyDown = (event, consentStatus) => {
		// Check for Enter or Space key press
		if (event.key === "Enter" || event.key === " ") {
			handleConsent(consentStatus);
		}
	};

	if (!showConsentBanner) {
		return null;
	}

	return (
		<PrivacyConsentBanner>
			<div className='privacy-content'>
				We value your privacy. We and our partners use trackers to measure the
				audience of our website and to provide you with offers and improve our
				own Witz marketing operations.
			</div>
			<ButtonGroup>
				<button
					className='privacy-consent-btn'
					onClick={() => handleConsent(false)}
					onKeyDown={(e) => handleKeyDown(e, false)}
				>
					DECLINE ALL
				</button>
				<button
					className='privacy-consent-btn'
					onClick={() => handleConsent(true)}
					onKeyDown={(e) => handleKeyDown(e, true)}
				>
					ACCEPT ALL
				</button>
			</ButtonGroup>
		</PrivacyConsentBanner>
	);
};

const PrivacyConsentBanner = styled.div`
	background-color: #ffffff;
	z-index: 1;
	width: 100%;
	text-align: center;
	position: fixed;
	bottom: 80px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 5px 0;
	.privacy-content {
		padding: 10px 25px;
		color: #596165;
		font-size: 14px;
		max-width: 700px;
	}
`;

const ButtonGroup = styled.div`
	display: flex;
	justify-content: center;
	padding: 10px 20px;
	gap: 1rem;
	flex-wrap: wrap;
	.privacy-consent-btn {
		background-color: #ffffff;
		border-radius: 40px;
		border: 1px solid #596165;
		color: #596165;
		font-size: 12px;
		min-width: 120px;
		height: 30px;
		cursor: pointer;
	}
	.privacy-consent-btn:hover {
		background-color: #aeb6ba;
		color: #ffffff;
		border: none;
	}
	@media (max-width: 768px) {
		flex-direction: column;
		gap: 10px;
		/* width: 100%; */
		.privacy-consent-btn {
			width: 335px;
			height: 36px;
		}
	}
`;

export default PrivacyConsent;
